import {
  Button,
  Dialog,
  FormControl,
  IconButton,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useState, useEffect, useRef } from "react";
import useSave from "../../Hooks/useSave";
import useDatatableAddon from "../../Hooks/useDatatableAddon";
import MUIDataTable from "mui-datatables";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import OpenInNew from "@mui/icons-material/OpenInNew";
import { CheckBox } from "@mui/icons-material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Divider from "@mui/material/Divider";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { usePrompt } from "../../Hooks/useBlocker";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useCookie } from "../../Hooks/useCookie";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import DataTable from "../../components/DataTable/DataTable";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import PrintIcon from "@mui/icons-material/Print";
import { BlobProvider, PDFViewer } from "@react-pdf/renderer";
import Labels from "./Labels";
import { use } from "react";

function sortBy(a, b, thenBy) {
  if (!a) return -1;
  if (!b) return +1;

  return a.localeCompare(b) || thenBy || 0;
}

export default function Order({ paper }) {
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const [order, setOrder] = useState({});
  const [open, setOpen] = React.useState(false);
  const [productRow, setProductRow] = useState();
  const [combinedWeight, setCombinedWeight] = useState();
  const [saved, setSaved] = useState(true);
  const [category, setCategory] = React.useState(
    location.pathname.includes("challah") ? "" : "CAKE"
  );
  const [openPrintDialog, setOpenPrintDialog] = useState(false);
  const [printQuantity, setPrintQuantity] = useState(1);
  const [printer, setPrinter] = useCookie("labelPrinter", "");
  const [printers, setPrinters] = useState([]);
  const [label, setLabel] = useState({});

  const isFirstRender = useRef(1);
  const { id } = useParams();
  const { fetchGraphql, DialogSave } = useSave(null);
  const navigate = useNavigate();

  usePrompt("If you leave without saving you will loss your data?", !saved);

  useEffect(() => {
    fetchGraphql({
      query: `query Order($orderId: ID!, $packingCategory: String) {
        order(orderId: $orderId) {
          orderId
          orderDate
          packDate
          deliveryDate
          packedBy
          orderedVia
          orderStatus
          createdBy
          lastEditedBy
          customerId
          customerName
          paymentStatus
          orderNote
        }
        orderProducts(orderId: $orderId, packingCategory: $packingCategory) {
          orderProductId
          orderId
          productId
          productCode
          productName
          productCategory
          productPrice
          priceByPound
          quantity
          packedQuantity
          packedWeight
          combinedId
        }
      }`,
      variables: {
        orderId: id,
        packingCategory: location.pathname.includes("challah")
          ? "challah"
          : "cake",
      },
    }).then((result) => {
      if (result.data.order.orderStatus === "Done") {
        navigate(`/packing/complete-order/${id}`);
      } else {
        setOrder(result.data.order);
        setProducts(
          result.data.orderProducts
            .sort((a, b) => a.priceByPound - b.priceByPound)
            .map((item, index) => ({
              ...item,
              uniqueCode: index,
            }))
        );
      }
    });
  }, []);

  useEffect(() => {
    if (isFirstRender.current === 1 || isFirstRender.current === 2) {
      isFirstRender.current = isFirstRender.current + 1;
      return;
    }

    setSaved(false);

    // console.log(products);
  }, [products]);

  useEffect(() => {
    fetchGraphql({
      query: `query GetPrinters {
        getPrinters {
          name
          printerId
        }
      }`,
    }).then((result) => {
      console.log(result.data.getPrinters);
      setPrinters(result.data.getPrinters);
    });
  }, []);

  const orderNotFullfiled = () =>
    products.map((item) => item.packedQuantity < item.quantity).includes(true);

  function createBackOrder() {
    fetchGraphql({
      query: `mutation CreateBackOrder($order: orderInput, $products: [orderProductInput], $order2: orderInput, $orderProducts: [orderProductInput], $orderId: ID!) {
        createBackOrder(order: $order, products: $products)
        updateOrderProducts(orderProducts: $orderProducts, orderId: $orderId, order: $order2) {
          orderProductId
          orderId
          productId
          productCode
          productName
          productPrice
          priceByPound
          quantity
          packedQuantity
          packedWeight
          combinedId
        }
        packOrder(orderId: $orderId, order: $order2) {
          orderStatus
        }
      }`,
      variables: {
        order: {
          deliveryDate: null,
          customerId: order.customerId,
          orderNote: `Backorder from order #${order.orderId} - ${
            order.orderNote || ""
          }`,
        },
        products: products
          .filter((item) => item.packedQuantity < item.quantity)
          .map((item) => ({
            productId: item.productId,
            quantity: item.quantity - item.packedQuantity,
          })),
        orderId: id,
        order2: {
          [location.pathname.includes("challah")
            ? "packedChallahStatus"
            : "packedCakeStatus"]: "Done",
        },
        orderProducts: products.map((item) => ({
          orderProductId: item.orderProductId,
          packedQuantity: parseFloat(item.packedQuantity),
          packedWeight: parseFloat(item.packedWeight),
          combinedId: Number(item.combinedId),
        })),
      },
    }).then((result) => {
      if (!result.errors) {
        setSaved(true);

        setTimeout(() => navigate(`/packing/cake/complete-order/${id}`), 500);
      } else {
        alert("your order has not bin saved - please try again");
      }
    });
  }

  function handleSaveOrder() {
    fetchGraphql({
      query: `mutation UpdateOrder($orderProducts: [orderProductInput], $orderId: ID!, $order: orderInput) {
          updateOrderProducts(orderProducts: $orderProducts, orderId: $orderId, order: $order) {
            orderProductId
            productCode
            productId
            productName
          }
        }`,
      variables: {
        order: {
          [location.pathname.includes("challah")
            ? "packedChallahStatus"
            : "packedCakeStatus"]: "Done",
        },
        orderId: id,
        orderProducts: products.map((item) => ({
          orderProductId: item.orderProductId,
          packedQuantity: parseFloat(item.packedQuantity),
          packedWeight: parseFloat(item.packedWeight),
          combinedId: Number(item.combinedId),
        })),
      },
    }).then((result) => {
      // console.log("we got here!");
      setSaved(true);

      setTimeout(
        () =>
          navigate(
            `/packing/${
              location.pathname.includes("challah") ? "challah" : "cake"
            }`
          ),
        500
      );
    });
  }

  function handleCompleteOrder() {
    const packedQuantity = products.map((item) => item.packedQuantity);

    const packedWeight = products
      .filter((item) => item.priceByPound)
      .map((item) => item.packedWeight);

    if (
      packedQuantity.includes(null) ||
      packedQuantity.includes(undefined) ||
      packedQuantity.includes("")
    ) {
      setOpen(1);
    } else if (
      packedWeight.includes(null) ||
      packedWeight.includes(undefined) ||
      packedWeight.includes("")
    ) {
      setOpen(3);
    } else {
      setOpen(5);
    }
  }

  const handleChange = (event, newCategory) => {
    setCategory(newCategory);
  };

  function completeOrder() {
    fetchGraphql({
      query: `mutation UpdateOrder($orderProducts: [orderProductInput], $orderId: ID!, $order: orderInput) {
          updateOrderProducts(orderId: $orderId, orderProducts: $orderProducts, order: $order) {
            orderProductId
            productCode
            productId
            productName
          }
          packOrder(orderId: $orderId, order: $order) {
            orderStatus
          }
        }`,
      variables: {
        orderId: id,
        order: {
          [location.pathname.includes("challah")
            ? "packedChallahStatus"
            : "packedCakeStatus"]: "Done",
        },
        orderProducts: products.map((item) => ({
          orderProductId: item.orderProductId,
          packedQuantity: parseFloat(item.packedQuantity),
          packedWeight: parseFloat(item.packedWeight),
          combinedId: Number(item.combinedId),
        })),
      },
    }).then((result) => {
      setSaved(true);

      setTimeout(
        () =>
          navigate(
            `/packing/${
              location.pathname.includes("challah") ? "challah" : "cake"
            }/complete-order/${id}`
          ),
        500
      );
    });
  }

  function handleClick() {
    const copyState = [...products];

    const selectedItems = copyState.filter((item) => item.selected === true);

    selectedItems.forEach((item) => (item.packedWeight = combinedWeight));

    selectedItems.forEach(
      (item) => (item.combinedId = selectedItems[0].orderProductId)
    );

    selectedItems.forEach((item) => (item.selected = false));

    setCombinedWeight(null);
    setProducts(copyState);
  }

  function groupBy(items, key) {
    return items.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [...(result[item[key]] || []), item],
      }),
      {}
    );
  }

  const groupedProducts = groupBy(
    category === "CAKE"
      ? products
          .filter((item) => item.combinedId > 0)
          .filter(
            (item) =>
              item.productCategory !== "PASTRY / DANISH" &&
              item.productCategory !== "CHALLOS / BREAD"
          )
      : category === "PASTRY / DANISH"
      ? products
          .filter((item) => item.combinedId > 0)
          .filter((item) => item.productCategory === "PASTRY / DANISH")
      : products
          .filter((item) => item.combinedId > 0)
          .filter((item) => item.productCategory === "CHALLOS / BREAD"),
    "combinedId"
  );

  async function printLabels(blob) {
    async function blobToBase64(blob) {
      const buffer = await blob.arrayBuffer();
      return btoa(
        new Uint8Array(buffer).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        )
      );
    }

    const base64 = await blobToBase64(blob);

    fetchGraphql({
      query: `mutation printLabels($blob: String, $printer: String) {printLabels(blob: $blob, printer: $printer)}`,
      variables: {
        blob: base64,
        printer: printer,
      },
    }).then(() => {
      console.log("label created");
    });

    console.log("print", blob);
    setPrintQuantity(1);
    setOpen(9);
  }

  async function getLabel(productId) {
    const result = await fetchGraphql(
      {
        query: `query Label($productId: ID) {
          label(productId: $productId) {
            label
            name
            productId
          }
        }`,
        variables: { productId },
      }
    )


    return result.data.label || {name: result.data.label.name, label: "No label found", productId: "error"};
  }

  async function handleOpenPrintDialog(product) {
    console.log("product", product);
    const label = await getLabel(product.productId);
    setLabel(label);
    setProductRow(product);
    setOpen(8);
  }

  const handleChangePrinter = (event) => {
    setPrinter(event.target.value);
  };

  const options = {
    sortable: false,
    toolbar: false,
    minColumnWidth: "100px",
    actionsMinWidth: "190px",
    allwaysEdit: true,
    onChange: (e, row, id) => {
      const copyState = [...products];

      const item = copyState.find(
        (item) => item.orderProductId === row.orderProductId
      );

      item[id] = e.target.value;

      setProducts(copyState);
    },
    check: (row) => {
      const copyState = [...products];

      const item = copyState.find(
        (item) => item.orderProductId === row.orderProductId
      );

      item.packedQuantity = item.quantity;

      setProducts(copyState);
    },
    uncheck: (row) => {
      const copyState = [...products];

      const item = copyState.find(
        (item) => item.orderProductId === row.orderProductId
      );

      item.packedQuantity = 0;

      if (row.priceByPound) {
        item.packedWeight = 0;
      }

      setProducts(copyState);
    },
    select: (row) => {
      return row.priceByPound;
    },
    selectFunc: (row) => {
      const copyState = [...products];

      const item = copyState.find(
        (item) => item.orderProductId === row.orderProductId
      );

      item.selected = !item.selected;

      setProducts(copyState);
    },
    // singleRowId: "combinedId",
    customRows:
      Object.keys(groupedProducts).map((item) => groupedProducts[item][0])[0] &&
      Object.keys(groupedProducts).map((item) => {
        return (
          <TableRow
            sx={{
              // minWidth: 650,
              minWidth: "100%",
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              height: "100%",
              overflow: "auto",
              borderBottom: "solid 1px #e0e0e0 !important",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                width: "80%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "75%",
                }}
              >
                {groupedProducts[item]?.map((row) => (
                  <Box
                    sx={{
                      display: "flex",
                      alignContent: "center",
                      width: "100%",
                      borderBottom: "1px solid #e0e0e0",
                      "&:last-child": {
                        border: 0,
                      },
                    }}
                  >
                    <TableCell
                      sx={{
                        width: "100%",
                        minWidth: "200px",
                        alignSelf: "center",
                        minHeight: "50px",
                        border: "none !important",
                      }}
                    >
                      <Box sx={{ display: "flex" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", mr: 1 }}
                        >
                          <PrintIcon
                            onClick={() => handleOpenPrintDialog(row)}
                          />
                        </Box>
                        <Box>
                          <Typography>{row.productName}</Typography>
                        </Box>
                      </Box>
                    </TableCell>

                    <TableCell
                      sx={{
                        width: "100%",
                        minWidth: "100px",
                        alignSelf: "center",
                        minHeight: "50px",
                        border: "none !important",
                      }}
                    >
                      {row.quantity}
                    </TableCell>

                    <TableCell
                      sx={{
                        width: "100%",
                        minWidth: "100px",
                        alignSelf: "center",
                        minHeight: "50px",
                        border: "none !important",
                      }}
                    >
                      <TextField
                        size="small"
                        type="number"
                        value={row.packedQuantity}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        onChange={(e) => {
                          const copyState = [...products];

                          const rowItem = copyState.find(
                            (item) => row.orderProductId === item.orderProductId
                          );

                          rowItem.packedQuantity = e.target.value;

                          setProducts(copyState);
                        }}
                      />
                    </TableCell>
                  </Box>
                ))}
              </Box>

              <TableCell
                sx={{
                  alignSelf: "center",
                  // height: "100%",
                  width: "25%",
                  minWidth: "100px",
                  border: "none !important",
                }}
              >
                <TextField
                  size="small"
                  type="number"
                  value={groupedProducts[item][0].packedWeight}
                  onChange={(e) => {
                    const copyState = [...products];

                    for (const orderProduct of groupedProducts[item]) {
                      const row = copyState.find(
                        (row) =>
                          row.orderProductId === orderProduct.orderProductId
                      );

                      row.packedWeight = e.target.value;
                    }

                    setProducts(copyState);
                  }}
                />
              </TableCell>
            </Box>

            <Box
              sx={{
                borderLeft: "dotted 1px gray !important",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <TableCell
                sx={{
                  alignSelf: "center",
                  height: "100%",
                  width: "20%",
                  border: "none !important",
                  minWidth: "190px",
                  minHeight: "50px",
                }}
              >
                <Tooltip title="Delete">
                  <IconButton
                    onClick={() => {
                      const copyState = [...products];

                      for (const orderProduct of groupedProducts[item]) {
                        const row = copyState.find(
                          (row) =>
                            row.orderProductId === orderProduct.orderProductId
                        );

                        row.combinedId = null;
                        row.packedWeight = null;
                      }

                      setProducts(copyState);
                    }}
                  >
                    <DeleteForeverIcon sx={{ color: "error.light" }} />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </Box>
          </TableRow>
        );
      }),
  };

  const columns = [
    {
      name: "orderProductId",
      view: false,
    },
    {
      name: "priceByPound",
      view: false,
    },
    {
      name: "disabled",
      view: false,
    },
    {
      id: "productName",
      name: "Name",
      minWidth: "200px",
      edit: () => false,
      customCell: (row, index) => (
        <Box sx={{ display: "flex" }}>
          <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
            <PrintIcon onClick={() => handleOpenPrintDialog(row)} />
          </Box>
          <Box>
            <Typography>{row.productName}</Typography>
          </Box>
        </Box>
      ),
    },
    {
      id: "quantity",
      name: "Quantity",
      edit: () => false,
    },
    {
      id: "packedQuantity",
      name: "Packed Quantity",
      type: "number",
    },
    {
      id: "selected",
      view: false,
      name: "Select",
    },
    {
      id: "packedWeight",
      name: "Packed Weight",
      edit: (row) => row.priceByPound,
      type: "number",
    },
  ];

  return (
    <>
      <DialogSave />
      {/* order not complete */}
      <Dialog
        open={open === 1}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Please complete the order to continue.
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ fontWeight: "bold" }}>
            These items have not been packed:
          </DialogContentText>
          {products
            .filter(
              (item) =>
                item.packedQuantity === null ||
                item.packedQuantity === undefined
            )
            .map((item) => {
              // console.log(item, "not packed");
              return (
                <DialogContentText id="alert-dialog-description">
                  {item.productName}
                </DialogContentText>
              );
            })}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => {
              e.preventDefault();
              setOpen(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      {/* are you sure you want to check */}
      <Dialog
        open={open === 6}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to change the amount to {productRow?.quantity}
        </DialogTitle>

        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={() => {
              const copyState = [...products];

              const row = copyState.find(
                (item) => item.orderProductId === productRow.orderProductId
              );

              row.packedQuantity = row.quantity;

              row.disabled = true;

              setProducts(copyState);
              setOpen(false);
            }}
            variant="contained"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      {/* are you sure you want to 0 */}
      <Dialog
        open={open === 7}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to change the amount to 0
        </DialogTitle>

        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={() => {
              const copyState = [...products];

              const row = copyState.find(
                (item) => item.orderProductId === productRow.orderProductId
              );

              row.packedQuantity = 0;

              row.disabled = false;

              setProducts(copyState);
              setOpen(false);
            }}
            variant="contained"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      {/* please enter the weight of these items */}
      <Dialog
        open={open === 3}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Please enter the weight of these items.
        </DialogTitle>
        <DialogContent>
          {products
            .filter(
              (item) =>
                item.priceByPound &&
                (item.packedWeight === null ||
                  item.packedWeight === undefined ||
                  item.packedWeight === "")
            )
            .map((item) => {
              return (
                <DialogContentText id="alert-dialog-description">
                  {item.productName}
                </DialogContentText>
              );
            })}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => {
              e.preventDefault();
              setOpen(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      {/* preview order */}
      <Dialog
        open={open === 5}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Preview order.</DialogTitle>

        <DialogContent>
          <Box
            sx={{
              display: "grid",
              minWidth: "300px",
              gridTemplateColumns: "7fr 1fr 1fr",
              alignItems: "center",
            }}
          >
            <DialogContentText sx={{ fontWeight: "bold" }}>
              Product name
            </DialogContentText>
            <DialogContentText sx={{ fontWeight: "bold" }}>
              Qt
            </DialogContentText>
            <DialogContentText sx={{ fontWeight: "bold" }}>
              Wt
            </DialogContentText>
            {products
              .filter((item) => !item.combinedId || item.combinedId === "0")
              .map((item) => {
                return (
                  <>
                    <Box>{item.productName}</Box>
                    <Box>{item.packedQuantity}</Box>
                    <Box>{item.packedWeight}</Box>
                  </>
                );
              })}
            {Object.keys(groupedProducts).map((item) => {
              // console.log(item);
              return (
                <>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    {groupedProducts[item]?.map((row) => (
                      <Box>{row.productName}</Box>
                    ))}
                  </Box>

                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    {groupedProducts[item]?.map((row) => (
                      <Box>{row.packedQuantity}</Box>
                    ))}
                  </Box>

                  <Box>{groupedProducts[item][0].packedWeight}</Box>
                </>
              );
            })}
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={() => {
              if (
                orderNotFullfiled() &&
                !location.pathname.includes("challah")
              ) {
                setOpen(4);
              } else {
                completeOrder();
              }
            }}
            variant="contained"
          >
            {location.pathname.includes("challah")
              ? "Complete Order"
              : orderNotFullfiled()
              ? "Next"
              : "Complete Order"}
          </Button>
        </DialogActions>
      </Dialog>
      {/* order complete - make backorder or not */}
      <Dialog
        open={open === 4}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Please select option to continue.
        </DialogTitle>

        <DialogContent>
          <DialogContentText sx={{ fontWeight: "bold" }}>
            These items have not been fulfilled:
          </DialogContentText>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "5fr 1fr",
            }}
          >
            {products
              .filter((item) => item.packedQuantity < item.quantity)
              .map((item) => {
                return (
                  <>
                    <Box>{item.productName}</Box>
                    <Box>{item.quantity - item.packedQuantity}</Box>
                  </>
                );
              })}
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              completeOrder();

              setOpen(false);
            }}
          >
            No Backorder
          </Button>

          <Button
            onClick={() => {
              createBackOrder();

              setOpen(false);
            }}
            variant="contained"
          >
            Create Backorder
          </Button>
        </DialogActions>
      </Dialog>
      {/* print dialog */}
      <Dialog
        open={open === 8}
        onClose={() => {
          setOpen(false)
          setPrintQuantity(1)
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Please enter the Label quantity.
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <PDFViewer>
              {label && <Labels productName={label.name} label={label.label} quantity={printQuantity} />}
            </PDFViewer>
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={printer}
                label="Age"
                onChange={handleChangePrinter}
              >
                {printers?.map((item) => (
                  <MenuItem value={item.printerId}>{item.name}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              type="number"
              label="Quantity"
              sx={{ marginBottom: "20px", backgroundColor: "white" }}
              value={combinedWeight}
              onChange={(e) => setPrintQuantity(e.target.value)}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <BlobProvider
            document={<Labels productName={label.name} label={label.label} quantity={printQuantity} />}
          >
            {({ blob, url, loading, error }) => {
              if (loading) return <div>Generating PDF...</div>;
              if (error) return <div>Error: {error.message}</div>;

              return <Button onClick={() => printLabels(blob)}>Print</Button>;
            }}
          </BlobProvider>
        </DialogActions>
      </Dialog>

      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Button
            variant="outlined"
            sx={{ margin: "0px auto 20px 0px" }}
            onClick={() =>
              navigate(
                `/packing/${
                  location.pathname.includes("challah") ? "challah" : "cake"
                }`
              )
            }
          >
            <ArrowBackIcon />
            Back
          </Button>

          <Box sx={{ marginLeft: "auto" }}>
            <Button
              variant="outlined"
              color={"success"}
              sx={{ marginRight: "20px" }}
              onClick={handleSaveOrder}
            >
              Save
            </Button>

            <Button variant="contained" onClick={handleCompleteOrder}>
              Complete Order
            </Button>
          </Box>
        </Box>

        <Paper
          sx={{
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            height: "calc(100% - 60px)",
          }}
        >
          {/* order details */}
          <Box sx={{ display: "flex", flexDirection: "row", width: "100%" }}>
            <Box>
              {order ? (
                <>
                  <div>
                    Order Id: <b>{order.orderId}</b>
                  </div>
                  <div>
                    Customer Name: <b>{order.customerName}</b>
                  </div>
                  <div>
                    Delivery Date: <b>{order.deliveryDate}</b>
                  </div>
                  {/* <div>
                  Created By: <b>{order.createdBy}</b>
                </div> */}
                  {/* <div>
                  Last Updated By: <b>{order.lastEditedBy}</b>
                </div> */}
                  <div>
                    Order Note: <b>{order.orderNote}</b>
                  </div>
                </>
              ) : null}
            </Box>
            <Box sx={{ marginLeft: "auto" }}>
              <ToggleButtonGroup
                color="primary"
                value={category}
                exclusive
                onChange={handleChange}
                aria-label="Platform"
              >
                {!location.pathname.includes("challah") && (
                  <ToggleButton value="CAKE">CAKE</ToggleButton>
                )}
                {!location.pathname.includes("challah") && (
                  <ToggleButton value="PASTRY / DANISH">
                    PASTRY / DANISH
                  </ToggleButton>
                )}
                {/* <ToggleButton value="CHALLOS/BREAD">CHALLOS/BREAD</ToggleButton> */}
              </ToggleButtonGroup>
            </Box>
          </Box>

          {/* table */}
          <Box sx={{ margin: "20px 0px", height: "calc(100% - 110px)" }}>
            {category === "CAKE" ? (
              <DataTable
                columns={columns}
                rows={products
                  ?.sort((a, b) => {
                    return sortBy(
                      String(a.priceByPound),
                      String(b.priceByPound)
                    );
                  })
                  .filter((item) => !item.combinedId || item.combinedId === "0")
                  .filter(
                    (item) =>
                      item.productCategory !== "PASTRY / DANISH" &&
                      item.productCategory !== "CHALLOS / BREAD"
                  )}
                options={options}
                name="Orders"
              />
            ) : category === "PASTRY / DANISH" ? (
              <DataTable
                columns={columns}
                rows={products
                  ?.sort((a, b) => {
                    return sortBy(
                      String(a.priceByPound),
                      String(b.priceByPound)
                    );
                  })
                  .filter((item) => !item.combinedId || item.combinedId === "0")
                  .filter((item) => item.productCategory === "PASTRY / DANISH")}
                options={options}
                name="Orders"
              />
            ) : (
              <DataTable
                columns={columns}
                rows={products
                  ?.sort((a, b) => {
                    return sortBy(
                      String(a.priceByPound),
                      String(b.priceByPound)
                    );
                  })
                  .filter((item) => !item.combinedId || item.combinedId === "0")
                  .filter((item) => item.productCategory === "CHALLOS / BREAD")}
                options={options}
                name="Orders"
              />
            )}
          </Box>
        </Paper>

        {products.map((item) => item.selected).includes(true) ? (
          <Paper
            sx={{
              zIndex: "2000",
              position: "fixed",
              bottom: "0",
              left: "0",
              margin: "50px",
              padding: "20px",
              backgroundColor: "#d4d4d4",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography sx={{ marginBottom: "20px" }}>
              Please enter combined weight
            </Typography>

            <TextField
              type="number"
              sx={{ marginBottom: "20px", backgroundColor: "white" }}
              value={combinedWeight}
              onChange={(e) => setCombinedWeight(e.target.value)}
            />
            <Button variant="contained" onClick={handleClick}>
              Ok
            </Button>
          </Paper>
        ) : null}
      </Box>
    </>
  );
}
